import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Box, TextField, Typography } from '@mui/material';
import range from '../../Helpers/Arrays/range';
import StyledSwitch from './StyledSwitch';

const RangeNumbersField = function RangeNumbersField({
  defaultValue = null,
  onChangeRangeValue = () => {},
  name = '',
  disabled = false,
  required = false,
  error = '',
}) {
  const intl = useIntl();
  const [value, setValue] = useState(defaultValue?.rawValue);
  const [exclude, setExclude] = useState(defaultValue?.exclude);

  const handleChangeExclude = (e) => {
    setExclude(e.target.checked);
  };

  const handleChangeValue = (e) => {
    setValue(e.target.value);
  };

  useEffect(() => {
    if (!value) {
      onChangeRangeValue({
        rawValue: '',
        range: [],
        exclude: false,
      });
      return;
    }
    if (value) {
      const arrayValues = value.split(',');

      onChangeRangeValue({
        rawValue: value,
        range: arrayValues
          .map((el) => {
            const splitEl = el.split('-');

            return range(
              parseInt(splitEl[0], 10),
              parseInt(splitEl[1] || splitEl[0], 10)
            );
          })
          .flat(),
        exclude,
      });
    }
  }, [value, exclude]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      <Typography sx={{ fontSize: '14px' }}>
        {intl.messages[name?.toUpperCase()]}:
      </Typography>
      <TextField
        id="range-numbers-field"
        placeholder={intl.messages.RANGE_NUMBERS_PLACEHOLDER}
        name={name}
        value={value}
        onChange={handleChangeValue}
        disabled={disabled}
        required={required}
        error={error}
        helperText={error}
      />
      <StyledSwitch
        id="exclude-selected-switch"
        label={intl.messages.EXCLUDE_SELECTED}
        disabled={!value}
        size="small"
        checked={exclude && value}
        onChange={handleChangeExclude}
        sx={{ marginTop: '4px', marginLeft: '11px', height: '38px' }}
      />
    </Box>
  );
};

export default RangeNumbersField;
